import { render } from "./NcrmPrivacyCallWarningDialog.vue?vue&type=template&id=7a7a6f96"
import script from "./NcrmPrivacyCallWarningDialog.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyCallWarningDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__